<template lang="pug">
    extends ../base/base.pug
    block input
        b-row
            b-col(md)
                label(
                    v-bind:for="slug + multi_field_num"
                )
                    = '{{ question }}'
                    span(
                    v-if="is_required"
                    class="requiredField"
                    ) *
            b-col(md)
                b-form-file(
                v-model="file"
                :ref="slug"
                :id="slug + multi_field_num"
                @input="send_file()"
                :required="is_required"
                :state="!is_error"
                :accept="accepted_file_types"
                plain
                )
                b-form-invalid-feedback
                    = '{{ error_message }}'
                b-form-text
                    = '{{ helper }}'
                p(v-show="answer")
                    b-btn(variant="secondary" size="sm" @click="delete_file")
                        | Remove
                    = ' {{ file_uploaded }}'
</template>
<script>
import Base from "../base";

export default {
	extends: Base,
	props: ["placeholder"],
	data() {
		return {
			file: null
		};
	},
	computed: {
		accepted_file_types: {
			get() {
				return this.$store.state[this.slug].accepted_file_types;
			}
		},
		file_uploaded() {
			if (this.answer) {
				return this.answer + " has been uploaded.";
			}

			return "";
		}
	},
	methods: {
		send_file() {
			let payload = {
				slug: this.slug,
				file: this.file
			};
			this.$store.dispatch("fileQuestion/send_file", payload);
		},
		delete_file() {
			this.$store.dispatch("fileQuestion/delete_file", this.slug);
		}
	}
};
</script>
